import React from "react";
import { Box, Stack } from "@mui/material";
import { ParlorDetailProps } from "../../types";

export function CostRangeSummary({
  defaultParlor,
}: {
  defaultParlor: ParlorDetailProps;
}) {
  const 무빈소 = defaultParlor.expected_charge_sum?.["무빈소"];
  const 일반장 = defaultParlor.expected_charge_sum?.["일반장"];

  if (!무빈소 || !일반장) return null;

  const min = Math.round(무빈소 / 10000).toLocaleString();
  const max = Math.round(일반장 / 10000).toLocaleString();

  return (
    <Stack gap="4px" margin="12px 0 20px">
      <Box className="subtitle_14_sb">
        장례 총 예상 비용 {min}만 ~ {max}만원
      </Box>
      <Box className="caption_12_r gray600" style={{ lineHeight: "1.4" }}>
        ※ 빈소 + 장례용품 + 음식 등 포함, 조문객 수 0명 ~ 150명 기준
      </Box>
      <Box className="caption_12_r gray600" style={{ lineHeight: "1.4" }}>
        ※ e하늘 장사정보시스템 기반 예상 비용이며, 실제와 다를 수 있습니다.
      </Box>
    </Stack>
  );
}
